import { useContext } from 'react';
import CreateGridProvider from 'providers/Grid';
import { IGridValue } from './types';

const { GridContext, GridProvider } = CreateGridProvider<IGridValue>();

const useAllGridData = () => {
  const { grid } = useContext(GridContext);

  if (!grid) {
    throw new Error(`useGridData must be used within a GridProvider`);
  }

  return grid;
};

const useGridData = (name: string) => {
  const { grid } = useContext(GridContext);

  if (!grid) {
    throw new Error(`useGridData must be used within a GridProvider`);
  }

  return (grid[name] || {}) as IGridValue;
};

const useDispatchGrid = (name: string) => {
  const { onChange } = useContext(GridContext);

  if (!onChange) {
    throw new Error(`useDispatchGrid must be used within a GridProvider`);
  }

  return (value: IGridValue) => {
    onChange({ [name]: value });
  };
};

export { useGridData, useDispatchGrid, useAllGridData, GridProvider };
